import { ConfirmActionModal } from '@/components/commons/confirm-action-modal'
import { useUpdateStepToAiVettingCompleted } from '@/features/photoset/queries/use-update-step-to-ai-vetting-completed'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS, queryClient } from '@/query-client'
import { useTranslation } from '@/translations/i18n'

export const AiVettingConfirmModal = ({
	photosetId,
	onClose
}: {
	photosetId: number
	onClose: () => void
}) => {
	const { t } = useTranslation()

	const updateStepToAiVettingCompleted = useUpdateStepToAiVettingCompleted({
		onError: (error) => errorHandler(error),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.PHOTOSET]
			})
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.PHOTOSET_SPACES]
			})
		}
	})

	return (
		<ConfirmActionModal
			headerTitle=''
			isLoading={updateStepToAiVettingCompleted.isPending}
			onClose={onClose}
			onConfirm={() => updateStepToAiVettingCompleted.mutate(photosetId)}
			paragraph={t('photoset:ai_vetting.modal.no_selection_subtitle')}
			title={t('photoset:ai_vetting.modal.no_selection_title')}
		/>
	)
}
